import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { reduxForm } from 'redux-form';
import { Form, Button, Grid } from 'semantic-ui-react';

// Selectors
// @ts-ignore
import { selectSelectedTableCellRows } from 'services/selectedTableCells/selectors';

interface Props {
    requestDeleteTimesheetEntries: Function;
    rowIds?: string[];
    onClose: Function;
    handleSubmit: Function;
    onSubmit: Function;
}

export class DeleteTimesheetEntriesForm extends React.PureComponent<Props> {
    handleSubmit = (): void => {
        const { rowIds, onClose, onSubmit } = this.props;
        onSubmit(rowIds);
        onClose();
    };

    render(): React.ReactElement {
        const { onClose, handleSubmit } = this.props;

        return (
            <Form
                onSubmit={handleSubmit(this.handleSubmit)}
                autoComplete="off"
            >
                <Grid>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Button
                            type="button"
                            onClick={(): void => onClose()}
                            fluid
                            basic
                            primary
                        >
                            Cancel
                        </Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Button type="submit" negative fluid>
                            Delete
                        </Button>
                    </Grid.Column>
                </Grid>
            </Form>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    rowIds: selectSelectedTableCellRows
});

export default connect(mapStateToProps)(
    reduxForm<any, any>({
        form: 'TIMESHEET_ENTRIES_DELETE'
    })(DeleteTimesheetEntriesForm)
);
